<template>
  <div class="block-content block-content-full border-bottom">
    <div class="row align-items-center">
      <div class="col py-5">
        <h3 class="h5 font-w700 mb-10">
          <i v-if="job.status === 'queued'" :class="`fa fa-hourglass-o text-warning mr-5`"></i>
          <i v-else-if="job.status === 'finished'" :class="`fa fa-check text-success mr-5`"></i>
          <i v-else-if="job.status === 'failed'" :class="`fa fa-times text-danger mr-5`"></i>
          <i v-else-if="job.status === 'executing'" :class="`fa fa-spinner fa-spin text-info mr-5`"></i>

          {{name}}<span v-if="job.status === 'executing'">...</span>
        </h3>

        <div class="progress mb-5" style="height: 8px;">
          <div v-if="job.status === 'queued'" class="progress-bar" role="progressbar" :style="{width: '0%'}"></div>
          <div v-else-if="job.status === 'finished'" class="progress-bar bg-success" role="progressbar" :style="{width: '100%'}"></div>
          <div v-else-if="job.status === 'failed'" class="progress-bar bg-danger" role="progressbar" :style="{width: `${progress}%`}"></div>
          <div v-else-if="job.status === 'executing'" class="progress-bar progress-bar-striped progress-bar-animated bg-info" role="progressbar" :style="{width: `${progress}%`}"></div>
        </div>

        <p v-if="job.status === 'queued'" class="font-size-sm font-w600 mb-0">In de wachtrij...</p>
        <p v-else-if="job.status === 'executing'" class="font-size-sm font-w600 mb-0">
          <span v-if="job.progress_max">
            <span class="font-w700">{{job.progress_now}}</span> van <span class="font-w700">{{job.progress_max}}</span>
          </span>
          <span v-else>Bezig...</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
const types = {
  'VMControl\\SalesChannel\\Jobs\\ImportProducts': 'Producten importeren',
  'VMControl\\SalesChannel\\Jobs\\ImportNewOrders': 'Bestellingen importeren'
}

export default {
  props: {
    job: Object
  },
  computed: {
    name () {
      return types[this.job.type]
    },
    progress () {
      const step = 100 / this.job.progress_max
      return step * this.job.progress_now
    }
  }
}
</script>



// WEBPACK FOOTER //
// JobListItem.vue?5de2ae32